import React, { useEffect, useState } from "react";
import authApiService from "../../services/authServices";
import { Link, useLocation, useSearchParams, useNavigate } from "react-router-dom";
import Modal from "../../utils/modalUtils";
import { jwtDecode } from "jwt-decode";
import {
    buildOriginalThread,
    composeOutgoingMessage,
    normalizeReplySubject,
} from "../../utils/messageThread";
import { getApiErrorMessage } from "../../utils/authError";



const MemberSendMessage = () => {
    const navigate = useNavigate();
    const [playerProfileData, setPlayerProfileData] = useState([]);
    const [loading, setLoading] = useState(false);
    const selectedCity = JSON.parse(localStorage.getItem("selectedCity"));
    const location = useLocation();
    const cityId = selectedCity?.id;
    const [searchParams] = useSearchParams();
    const MRId = searchParams.get("userId");
    const [formData, setFormData] = useState({
        subject: '',
        to: location.state?.recipientName || '',
        message: '',
        cityId: cityId
    });
    const [originalThread, setOriginalThread] = useState("");
    const [sentToName, setSentToName] = useState("");
    const isReply = Boolean(originalThread);

    const fetchPlayerProfile = async () => {
        if (!MRId) return;
        try {
            const response = await authApiService.get(`member-details/${MRId}`);
            const details = response?.data;
            if (!details) return;
            setPlayerProfileData({
                fullName: details.name || details.fullName || "",
                rating: details.playerNumber ?? details.rating ?? "",
                homeCourt: details.homeCourt || details.courtName || "",
                tournamentRecord: details.seasonRecord || "0-0",
                bestResults: details.bestResult || details.bestResults || "",
            });
            if (details.name || details.fullName) {
                setFormData((prev) => ({
                    ...prev,
                    to: details.name || details.fullName,
                }));
            }
        } catch (error) {
            console.error("Error fetching player profile data:", error);
        }
    };

    useEffect(() => {
        fetchPlayerProfile();
    }, [MRId]);

    /**
     * Handles form input changes
     * @param {Event} e - The change event
     */
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    /**
     * Handles form submission for sending messages
     * Validates access token and sends message based on user role
     * @param {Event} e - The form submit event
     */
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            // Validate access token
            const accessToken = localStorage.getItem("accessToken");

            if (!accessToken) {
                Modal.fire({
                    icon: "error",
                    title: "Error",
                    text: "You must be logged in to send a message. Please log in again.",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#addd1e"
                });
                setLoading(false);
                return;
            }

            let decodedToken = null;
            try {
                decodedToken = jwtDecode(accessToken);
            } catch (decodeError) {
                decodedToken = null;
            }

            // For /carter/sendMessage page, always send PRIVATE message to selected user.
            if (!MRId) {
                Modal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Receiver not found. Please try again.",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#addd1e"
                });
                setLoading(false);
                return;
            }

            const senderId = decodedToken?.userId;
            if (senderId != null && String(senderId) === String(MRId)) {
                Modal.fire({
                    icon: "error",
                    title: "Error",
                    text: "You can't send message to yourself.",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#addd1e"
                });
                setLoading(false);
                return;
            }

            const outgoing = composeOutgoingMessage(formData.message, originalThread);
            if (!outgoing) {
                Modal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Message is required.",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#addd1e"
                });
                setLoading(false);
                return;
            }

            const payload = {
                receiver: MRId,
                subject: formData.subject,
                message: outgoing,
            };

            const response = await authApiService.post("privateMessage", payload);
            if (response && (response.code === 200 || response.data)) {
                const recipientName =
                    String(formData.to || playerProfileData?.fullName || "player").trim() || "player";
                setSentToName(recipientName);
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    subject: "",
                    message: "",
                }));
                setOriginalThread("");
            }
        } catch (error) {
            console.error('Error sending message:', error);
            const status = error?.response?.status;
            const needsLogin = status === 401 || status === 403;
            const result = await Modal.fire({
                icon: "error",
                title: "Error",
                text: getApiErrorMessage(error, "Message not sent. Please try again."),
                confirmButtonText: needsLogin ? "Log in" : "OK",
                confirmButtonColor: "#addd1e"
            });
            if (needsLogin && result?.isConfirmed) {
                localStorage.removeItem("accessToken");
                window.location.href = "/";
            }
        }
        setLoading(false);
    };



    useEffect(() => {
        const passedMessage = location.state?.message;
        if (passedMessage) {
            setFormData((prevFormData) => ({
                ...prevFormData,
                subject: normalizeReplySubject(passedMessage.subject),
                message: "",
            }));
            setOriginalThread(buildOriginalThread(passedMessage.message || "No content"));
        }
    }, [location.state]);



    useEffect(() => {
        if (playerProfileData?.fullName) {
            setFormData((prevFormData) => ({
                ...prevFormData,
                to: playerProfileData.fullName,
            }));
        }
    }, [playerProfileData]);


    return (
        <div className="page-container col-sm-9 send-message-page">
            <div
                className="courts-page-heading"
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px" }}
            >
                <h2 style={{ margin: 0, color: "#fff" }}>New Message</h2>
                <img
                    src="/images/inbox.png"
                    alt="Message"
                    style={{ width: 26, height: 26, objectFit: "contain" }}
                />
            </div>
            <div className="msgboard-section send-message-layout">
                <div className="send-message-profile">
                        <div className="msguser sentMsgSection h-auto">
                            <div className="player-info members-listing-desc memberBox-bg w-100 h-100 shadow">
                                <div className="left">
                                    <table className="show-profile-info">
                                        <tbody>
                                            <tr>
                                                <td className=" text-center">
                                                    <img src="/images/icon-6.png" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    align="center"
                                                    style={{ padding: "9px 0px", textAlign: "center" }}
                                                >
                                                    <div className="buttonwrapper">
                                                        <Link
                                                            to={`/carter/profile?userId=${MRId}`}
                                                            className="squarebutton"
                                                        >
                                                            <span>View Profile</span>
                                                        </Link>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <h2 className="playerINfotitle">
                                                        {playerProfileData?.fullName}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">
                                                    <h3 className="">&nbsp;{playerProfileData?.rating} Rating</h3>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="clear" />
                                <div className="subsection p1">
                                    <div className="flu-box">
                                        <p
                                            className="overflowText"
                                            style={{
                                                overflow: "hidden",
                                                whiteSpace: "nowrap",
                                                textOverflow: "ellipsis"
                                            }}
                                        >
                                            Home Court: {playerProfileData?.homeCourt}
                                        </p>
                                        <p className="text-center">
                                            Season Record:{" "}
                                            <Link
                                                to={`/carter/members/record`}
                                                className="green"
                                                state={{ memberId: MRId, recordType: "tournament" }}
                                            >
                                                {playerProfileData?.tournamentRecord ?? "0-0"}
                                            </Link>
                                        </p>
                                       
                                        <p className="msg-link-btn">
                                        <Link
                                                to={`/carter/schedule?userId=${MRId}`}
                                                className="msg-link"
                                            >
                                                Schedule
                                            </Link>
                                            {/* <Link
                                                to={`/carter/sendMessage?userId=${MRId}`}
                                                className="msg-link ie-post-link"
                                            >
                                                Message
                                            </Link> */}
                                        </p>
                                        <p className="pt-2 mb-0 overflowText" style={{ clear: "both" }}>
                                            Best Results: <span className="green">{playerProfileData.bestResults ? playerProfileData.bestResults : "N/A"}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
                {sentToName ? (
                    <div className="compose message-sent-view send-message-fields">
                        <p className="message-sent-text" style={{ fontSize: 18, color: "#F70A0A", fontWeight: 700 }}>
                            Your message to {sentToName} has been sent
                        </p>
                    </div>
                ) : (
                    <form id="msgForm" className="compose send-message-form" onSubmit={handleSubmit}>
                        <div className="send-message-fields">
                            <div className="send-field-row">
                                <div className="send-gray-box">
                                    <label htmlFor="to">To:</label>
                                    <input
                                        type="text"
                                        disabled
                                        id="to"
                                        value={formData.to}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="send-gray-box">
                                    <label htmlFor="subject">Subject:</label>
                                    <input
                                        id="subject"
                                        name="subject"
                                        type="text"
                                        maxLength={50}
                                        value={formData.subject}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="send-gray-box send-message-box">
                                {isReply ? (
                                    <>
                                        <pre className="original-in-box">{originalThread}</pre>
                                        <label htmlFor="message" className="response-label">Response:</label>
                                        <textarea
                                            id="message"
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        />
                                    </>
                                ) : (
                                    <>
                                        <label htmlFor="message">Message:</label>
                                        <textarea
                                            id="message"
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        />
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="send-message-actions">
                            <button
                                type="submit"
                                className="green_btn"
                                disabled={loading}
                            >
                                Send
                            </button>
                            <button
                                type="button"
                                className="gray_btn"
                                onClick={() => {
                                    navigate(isReply ? "/carter/inboxboard" : "/carter/profile");
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    )
}

export default MemberSendMessage